export default "__VITE_ASSET__DZwELqgu__"